
import { Placement } from '@post-office/placements-frontend/goals-app-changeboarding';
export default Placement;
